import { useCallback, useState } from 'react';

import { getLocalStorageItem, setLocalStorageItem } from '@atlassian/search-common/local-storage';

import { getSearchPageFilterConfigKey } from '../../constants/filters';
import type { ProductKeys } from '../../constants/product-keys';

export const useAppFilterState = (): any[] => {
	const [storedState, setStoredState] = useState(
		getLocalStorageItem(getSearchPageFilterConfigKey()) || {},
	);

	const setFilterHidden = useCallback(
		(productKey: ProductKeys, value: boolean) => {
			const newValue = {
				...storedState,
				filters: {
					...storedState?.filters,
					[productKey]: {
						hidden: value,
					},
				},
			};
			setStoredState(newValue);
			setLocalStorageItem(getSearchPageFilterConfigKey(), JSON.stringify(newValue));
		},
		[storedState, setStoredState],
	);

	return [storedState, { setFilterHidden }];
};
